import { render } from "./Lsa.vue?vue&type=template&id=e8d8f81c"
import script from "./Lsa.vue?vue&type=script&lang=js"
export * from "./Lsa.vue?vue&type=script&lang=js"

import exportComponent from "/builds/benoit67/django-business-center-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__